function SearchParentsFor( start, cls, top )
{
    var result;

    var parent = start.parentNode;
    if ( ( parent ) && (  parent.getAttribute ) )
    {
        var pcls = parent.getAttribute( "class" );
        if ( pcls )
        {
            var pclsArray = pcls.split( " " );
            for ( var i = 0; i < pclsArray.length; i++ )
            {
                if ( pclsArray[ i ] == cls )
                {
                    result = parent;
                    break;
                }
            }
        }

        if ( ( !result ) && ( ( !top ) || ( parent != top ) ) )
        {
            result = SearchParentsFor( parent, cls, top );
        }
    }

    return ( result );
}

function hideCatalogueCTA( )
{
    var catalogueBadge = document.querySelector( ".badge-catalogue" );
    if( catalogueBadge )
    {
        var span           = catalogueBadge.querySelector( ".after-span" );
        catalogueBadge.classList.remove( "active" )
        span.removeAttribute( "style", "display" )
    }
}

$(document).ready(function () {
    var catalogueBadge = document.querySelector( ".badge-catalogue" );
    if( catalogueBadge )
    {
        if($(window).width()<=1024){
            // catalogueBadge.classList.add( "active" )
        }
        if (window.location.href.indexOf("/products/") > -1) {
            $( ".after-span" ).show();
        }else{
            // catalogueBadge.classList.add( "active" )
        }
    }

    // Catalogue CTA - OOS
    var postButton    = document.querySelector('.action_button[data-method="post"]');
    var postContainer = document.querySelector('.post-container.catalogue_form-container');
    var checkboxes    = document.querySelectorAll('.catalogues-container-item input[type="checkbox"]');

    function updatePostButtonVisibility( e ) {
        var atLeastOneSelected = false;
        var inStockExists = false;
        var checkbox = e.currentTarget;

        var catalogueItem = checkbox.closest( ('.catalogues-container-item') );
        var showOOSText = catalogueItem.querySelector('.subheader.catalogue-oos');
        if (checkbox.checked)
        {
            atLeastOneSelected = true;
            var bookOuter = checkbox.closest('.catalogues-container-item').querySelector('.book_image_outer');
            var isOutOfStock = bookOuter.dataset.outOfStock === 'true';
            if (!isOutOfStock)
            {
                inStockExists = true;
                showOOSText.classList.add('hidden');
            }
            else
            {
                showOOSText.classList.remove('hidden');
            }
        }
        else
        {
            showOOSText.classList.add('hidden');
        }

        if (!atLeastOneSelected || inStockExists)
        {
            postButton.classList.remove('hidden');
        }
        else
        {
            postButton.classList.add('hidden');
            if( postContainer.classList.contains('hidden') == false )
            {
                postContainer.classList.add('hidden');
            }
        }
    }

    checkboxes.forEach(cb => cb.addEventListener('change', updatePostButtonVisibility));
});

function controlCatalogueFormScroll( )
{
    var body = document.body;
    body.classList.toggle('noscroll');
}

function showCataloguePopup( el )
{
    var cataloguePopup = document.querySelector( ".bridgman_homepage-catalogue_panel_underlay" );
    var parent         = SearchParentsFor( el, "bridgman_catalogue_wrapper" );
    function toggleCataloguePopup( cataloguePopup )
    {
        if( cataloguePopup.classList.contains( "hidden" ) )
        {
            cataloguePopup.classList.remove( "hidden" );
        }
        else
        {
            cataloguePopup.classList.add( "hidden" );
        }
    }

    if( parent )
    {
        var redirect        = parent.getAttribute( "data-redirect" )
        if( redirect )
        {
            window.location.href = redirect;
        }
        else
        {
            toggleCataloguePopup( cataloguePopup );
        }
    }
    else
    {
        toggleCataloguePopup( cataloguePopup );
    }
}

document.addEventListener( "scroll", function() {
    if( window.innerWidth <= 1024 )
    {
        // hideCatalogueCTA( );
    }
} );

function verifyCatalogueChoice( )
{
    var catalogueIsSelected = false;
    var catalogues          = document.querySelectorAll( ".book_image_outer" );

    for( var i = 0; i < catalogues.length; i++ )
    {
        var catalogue = catalogues[ i ]

        if( catalogue.classList.contains( "active" ) )
        {
            catalogueIsSelected = true;
            break;
        }
    }

    return catalogueIsSelected;
}

function showUserInputForm( element )
{
    var catalogueSendMethod = element.dataset.method;
    var contactFormContainers = document.querySelectorAll( ".catalogue_form-container" );
    var error = document.getElementById( "catalogue-select-error" );

    if( verifyCatalogueChoice( ) )
    {
        for( var i = 0; i < contactFormContainers.length; i++ )
        {
            var contactFormContainer = contactFormContainers[ i ];
            var contactForm = contactFormContainer.querySelector( ".catalouge-form" );
          	var formSendMethod;
            if( contactForm )
            {
              	if( contactForm.dataset.type )
                {
                	formSendMethod = contactForm.dataset.type;
                }
              	else if( contactForm.dataset.method )
                {
                 	formSendMethod = contactForm.dataset.method;
                }
            }
            contactFormContainer.classList.add( "hidden" );

            if( formSendMethod == catalogueSendMethod )
            {
                contactFormContainer.classList.remove( "hidden" );
                error.style.visibility = "hidden";
            }
        }
    }
    else
    {
        error.style.visibility = "visible";
    }
}

function setTelInputFilter(textbox, inputFilter)
{
    // var inputArray = [ ...textbox ];
    // Convert HTML Collection to an array:
    var inputArray = Array.prototype.slice.call(textbox)
    var eventArray = ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"];

    for( var i = 0; i < eventArray.length; i++ )
    {
        var event = eventArray [ i ]
        for( var j = 0; j < inputArray.length; j++ )
        {
            var input = inputArray[ j ];
            input.addEventListener(event, function() {
            if (inputFilter(this.value)) {
                this.oldValue = this.value;
                this.oldSelectionStart = this.selectionStart;
                this.oldSelectionEnd = this.selectionEnd;
            } else if (this.hasOwnProperty("oldValue")) {
                this.value = this.oldValue;
                this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
            } else {
                this.value = "";
            }
            });
        }
    }
}

/////////////////////////////////////////////////////////////
//Klaviyo
////////////////////////////////////////////////////////////
function HandleCTASuccess( arr )
{
    var qp = "";
    var multipleTypes = [];

    if( arr.length > 1 )
    {
        var responseType = "";
        for( var i = 0; i < arr.length; i++ )
        {
            var catalogue = arr[ i ];
            multipleTypes.push( catalogue.Catalogue_Type.replace(/\s+/g, '-') )
            responseType = catalogue.Response_Type
        }
        qp = multipleTypes.join( "&" ) + "-" + responseType;
    }
    else
    {
        try{
            var strippedType = arr[ 0 ].Catalogue_Type.replace(/\s+/g, '-')
        qp += strippedType + "-" + arr[ 0 ].Response_Type;
        }catch
        {
            qp = "consultation";
        }

    }

    qp = qp.toLowerCase();

    window.lintrk('track', { conversion_id: 24030218 });
    fbq('track', 'Lead', {});

    setTimeout(function()
    {
        var redirection_URL = window.location.origin + "/pages/thank-you?type=" + encodeURIComponent( qp );
        if (arr[ 0 ].Response_Type == "POST") {
            redirection_URL += '&' + "Postcode="+arr[ 0 ].Postcode.replace(/\s+/g, '-');
        }
        window.location.href = redirection_URL;
    }, 1000);
}

function SendToKlaviyo( param, e, cb )
{
    function TryNow( e )
    {
        if ( window._learnq )
        {
            window._learnq.push( param );
            cb();

        }
        else
        {
            setTimeout( TryNow, 500 );
        }
    }
    TryNow( e );
    console.log('send to Klav')
}

function onSearchBlur()
{
    var mannualAddress = document.querySelector('#manual-address');
    mannualAddress.checked = false;
}

$( document ).ready(function ()
{
    setTelInputFilter(document.querySelectorAll(".number-input"), function(value)
    {
        return /^\d*\.?\d*$/.test(value); // Allow digits and '.' only, using a RegExp
    });

    $("#catalogue_form").submit(function (e)
    {
        e.preventDefault();
        e.stopImmediatePropagation();    // This is to prevent the .submit firing twice

        hj("event","retail_catalogue_request");
        var selectedCatalogues = document.querySelectorAll( ".single_book .active" );
        var catalogueArray = [];
        function HandleOneCatalogue( idx )
        {
            
            if( idx < selectedCatalogues.length )
            {
                var form    = e.currentTarget;
                var _learnq = _learnq || [];
                var Catalogue_Type = "";
                var Catalogue_Name = "";
                var requestForBoth = false;
        
                for ( var idx = 0; idx < selectedCatalogues.length; idx++ ) 
                {
                    var currentCatalogue = selectedCatalogues[idx];
                    var catalogueType = currentCatalogue.getAttribute( "data-catalogue-type" );
                    var catalogueName = currentCatalogue.getAttribute( "data-catalogue-name" );

                    if ( idx > 0 ) 
                    {
                        Catalogue_Type += " and ";
                    }
                    Catalogue_Type += catalogueType;

                    if ( idx === 0 ) 
                    {
                        Catalogue_Name = catalogueName; 
                    } else 
                    {
                        Catalogue_Name = "BOTH - Home Furniture and Garden Furniture Catalogues";
                        requestForBoth = true;
                    }
                }
                var first_name = form.querySelector( "#catalogue_First_Name" ).value;
                var last_name = form.querySelector( "#catalogue_Last_Name" ).value;
                var phone_number = form.querySelector( "#catalogue_Phone" ).value;
                var email = form.querySelector( "#catalogue_email" ).value;
                var Postcode = form.querySelector( '[name="catalogue_Postcode"]' ).value;
                var accepts_marketing = form.querySelector( "input[ name='data-capture' ]" ).checked;
                var Where_did_you_hear_about_us = form.querySelector( '[name="catalogue_Where_did_you_hear_about_us"]' ).value;
                var have_you_heard_of_bridgman_before = 'No';
                
                var selectedRadio = form.querySelector( 'input[name="have_you_heard_of_bridgman_before"]:checked' );
                if ( selectedRadio !== null ) 
                {
                    have_you_heard_of_bridgman_before = selectedRadio.value;
                }
                
                if(Where_did_you_hear_about_us == 'Other'){
                    Where_did_you_hear_about_us = form.querySelector( '[name="catalogue_Where_did_you_hear_about_us_other"]' ).value;
                }
                var catalogue = 
                {
                    Response_Type: 'Email',
                    Catalogue_Type: Catalogue_Type,
                    Catalogue_Name: Catalogue_Name,
                    Request_For_Both: requestForBoth,
                    Postcode:Postcode,
                    $source: Where_did_you_hear_about_us,
                    $first_name: first_name,
                    $last_name: last_name,
                    $phone_number: phone_number,                    
                    $email: email,          
                    $have_you_heard_of_bridgman_before:have_you_heard_of_bridgman_before
                };

                if( accepts_marketing && accepts_marketing == true )
                {
                    catalogue.$accepts_marketing = accepts_marketing;
                }
 
                catalogueArray.push( catalogue );

                if( catalogue.$accepts_marketing )
                {
                    var properties  =  { "$email" : email, "Catalogue_Type" : catalogue.Catalogue_Type, "Catalogue_Name" : catalogue.Catalogue_Name, "$source": catalogue.$source, "Response_Type" : "Email", "$accepts_marketing": catalogue.$accepts_marketing };
                }
                else
                {
                    var properties  =  { "$email" : email, "Catalogue_Type" : catalogue.Catalogue_Type, "Catalogue_Name" : catalogue.Catalogue_Name, "$source": catalogue.$source, "Response_Type" : "Email" };
                }
                var trackProperties  = { "event" : "Request Catalogue", "trackData" : catalogue };
                KlaviyoTrackV2( properties, trackProperties, function()
                {
                    jQuery.post( "https://hooks.zapier.com/hooks/catch/9220888/o0xxmfx/silent/", catalogue ).then( function()
                    {
                        HandleOneCatalogue( idx + 1 );
                    } );
                });
            }
            else
            {
                if( e )
                {
                    HandleCTASuccess( catalogueArray );
                }
            }
        }
        HandleOneCatalogue( 0 );

    });

    $("#catalogue_form_post").submit(function (e)
    {
        e.preventDefault();
        e.stopImmediatePropagation();    // This is to prevent the .submit firing twice

        hj("event","retail_catalogue_request");
        var selectedCatalogues = document.querySelectorAll( ".single_book .active" );
        var catalogueArray = [];
        function HandleOneCatalogue( idx )
        {
            if( idx < selectedCatalogues.length )
            {
                var Catalogue_Type = "";
                var Catalogue_Name = "";
                var requestForBoth = false;
        
                for ( var idx = 0; idx < selectedCatalogues.length; idx++ ) 
                {
                    var currentCatalogue = selectedCatalogues[idx];
                    var catalogueType = currentCatalogue.getAttribute( "data-catalogue-type" );
                    var catalogueName = currentCatalogue.getAttribute( "data-catalogue-name" );        
                    
                    if ( idx > 0 ) 
                    {
                        Catalogue_Type += " and ";
                    }
                    Catalogue_Type += catalogueType;

                    if ( idx === 0 ) 
                    {
                        Catalogue_Name = catalogueName; 
                    } else 
                    {
                        Catalogue_Name = "BOTH - Home Furniture and Garden Furniture Catalogues";
                        requestForBoth = true;
                    }
                }
          

                var _learnq = _learnq || [];
                var form    = e.currentTarget;
                form = form.querySelector(".postbox");
                // var email = form.querySelector( "#catalogue_email" ).value;
                var email = form.querySelector( "#catalogue_email" ).value;
                // console.log(email)
                var First_Name = form.querySelector( "#catalogue_First_Name" ).value;
                var Last_Name = form.querySelector( "#catalogue_Last_Name" ).value;
                var Postcode = form.querySelector( '[name="catalogue_Postcode"]' ).value;
                // console.log(Postcode)
                var Address_Line_1 = form.querySelector( '[name="catalogue_Address_Line_1"]' ).value;
                var Address_Line_2 = form.querySelector( '[name="catalogue_Address_Line_2"]' ).value;
                var City = form.querySelector( '[name="catalogue_City"]' ).value;
                var Country = form.querySelector( '[name="catalogue_Country"]' ).value;
                var Phone = form.querySelector( '[name="catalogue_Phone"]' ).value;
                var have_you_heard_of_bridgman_before = 'No';

                var selectedRadio = form.querySelector( 'input[name="have_you_heard_of_bridgman_before"]:checked' );
                
                if ( selectedRadio !== null ) 
                {
                    have_you_heard_of_bridgman_before = selectedRadio.value;
                }
                               
                
                var Where_did_you_hear_about_us = form.querySelector( '[name="catalogue_Where_did_you_hear_about_us"]' ).value;
                if(Where_did_you_hear_about_us == 'Other'){
                    Where_did_you_hear_about_us = form.querySelector( '[name="catalogue_Where_did_you_hear_about_us_other"]' ).value;
                }
                var accepts_marketing = form.querySelector( "input[ name='data-capture' ]" ).checked;

                var catalogue = {
                    Response_Type: 'POST',
                    Catalogue_Type: Catalogue_Type,
                    Catalogue_Name: Catalogue_Name,
                    Request_For_Both: requestForBoth,
                    Postcode:Postcode,
                    $email: email,
                    $first_name:First_Name,
                    $last_name:Last_Name,
                    $address1:Address_Line_1,
                    $address2:Address_Line_2,
                    $city:City,
                    $country:Country,
                    $phone_number:Phone,
                    $source:Where_did_you_hear_about_us,
                    $have_you_heard_of_bridgman_before:have_you_heard_of_bridgman_before
                };

                if( accepts_marketing && accepts_marketing == true )
                {
                    catalogue.$accepts_marketing = accepts_marketing;
                }

                catalogueArray.push(catalogue);

                if( catalogue.$accepts_marketing )
                {
                    var properties  =  { "$email" : email, "Catalogue_Type" : catalogue.Catalogue_Type, "Catalogue_Name" : catalogue.Catalogue_Name, "$source": catalogue.$source, "Response_Type" : "POST", "$accepts_marketing": catalogue.$accepts_marketing };
                }
                else
                {
                    var properties  =  { "$email" : email, "Catalogue_Type" : catalogue.Catalogue_Type, "Catalogue_Name" : catalogue.Catalogue_Name, "$source": catalogue.$source, "Response_Type" : "POST" };
                }
                var trackProperties  = { "event" : "Request Catalogue", "trackData" : catalogue };
                KlaviyoTrackV2( properties, trackProperties, function()
                {
                    jQuery.post( "https://hooks.zapier.com/hooks/catch/9220888/o0xxmfx/silent/", catalogue ).then( function()
                    {
                        HandleOneCatalogue( idx + 1 );
                    } );
                });
            }
            else
            {
                if( e )
                {
                    HandleCTASuccess( catalogueArray );
                }
            }
        }
        HandleOneCatalogue( 0 );
    });

});
